import React, { useContext } from 'react';
import Btns from './btns';
import { useHistory } from 'react-router-dom';
import MenuMainCategory from '../menu-category/menu-main-category';
import { Context } from '../../../context/global-data-provider';
import Svg from '../../components/icons/svg';
import MemberNav from './member-nav';

function NavWithBackButton() {
  const { options } = useContext(Context);
  let history = useHistory();

  function handleBackButton() {
    history.goBack();
  }

  return (
    <header className="head-nav">
      <div className="fb-fix" />
      <div className="nav align-items-center">
        <div className="d-flex f-row align-items-center justify-content-end">
          <div className="btns d-flex f-row justify-content-start align-items-center align-content-center f-wrap-wrap f-100">
            <div className="d-flex f-row w-space-nowrap">
              <div className="item w-space-nowrap justify-content-center">
                <MemberNav />
              </div>

              <div className="item w-space-nowrap justify-content-center">
                <MenuMainCategory />
              </div>

              <div
                className="item w-space-nowrap justify-content-center"
                onClick={() => {
                  window.scrollTo(0, 0);
                }}
              >
                <Btns path="/" btn="home" />
              </div>

              <div className="item w-space-nowrap justify-content-center">
                <a href={`https://instagram.com/_u/${options.instagram}`} className="d-flex" target="_blank">
                  <Svg name={'instagram'} width={22} height={22} fill={'#E1306C'} label={'Instagram profile'} />
                </a>
              </div>

              <Rubika link={options.rubika_link || options.whatsapp_link} />

              <div className="item w-space-nowrap justify-content-center">
                <a href={`tel:${options.phone}`} className="d-flex" target="_blank">
                  <Svg name={'phone'} width={22} height={22} fill={'#565656'} label={'Phone'} />
                </a>
              </div>
            </div>
          </div>

          <div onClick={handleBackButton} className="c-p">
            <span className="d-inline-block" style={{ transform: 'rotate(270deg)' }}>
              <Svg name={'angleTop'} width={24} height={24} fill={'#565656'} label={'Back'} />
            </span>
          </div>
        </div>
      </div>
    </header>
  );
}

function Rubika(props) {
  if (!props.link) {
    return null;
  }

  return (
    <div className="item w-space-nowrap justify-content-center">
      <a href={props.link} target="_blank" rel="noopener noreferrer" className="d-flex">
        <Svg name={'rubika'} width={22} height={22} fill={'#7B2CBF'} label={'Rubika'} />
      </a>
    </div>
  );
}

export default NavWithBackButton;
